import { Button, Col, Form, Input, notification, Row } from 'antd'
import React, { Component } from 'react'
import { PricingAPI } from '../../controller/PricingAPI';
import withRouterHistoryHook from '../../hoc/withRouterHistoryHook';

export class LoginPage extends Component {
    state = {
        loading: false,
    };
    onLogin = (values) => {
        this.setState({ loading: true });
        PricingAPI.auth.login(values.email, values.password).then((response) => {
            notification.info({ message: '登入成功' });
        }).catch((error) => {
            notification.info({ message: '登入失敗' });
        }).finally(() => {
            this.setState({ loading: false });
        });
    };
    render() {
        return (
            <div style={{ padding: 20, position: 'absolute', width: '100%', top: '30vh' }}>
                <Row justify="center">
                    <Col xs={24} sm={16} md={14} lg={12} xl={10} xxl={6} style={{ textAlign: 'center' }}>
                        <h1>禾風新棧決策支援系統</h1>
                    </Col>
                </Row>
                <Row justify="center">
                    <Col xs={24} sm={16} md={14} lg={12} xl={10} xxl={6}>
                        <Form layout="vertical" onFinish={this.onLogin}>
                            <Form.Item label="E-mail" name="email">
                                <Input />
                            </Form.Item>
                            <Form.Item label="密碼" name="password">
                                <Input.Password />
                            </Form.Item>
                            <Form.Item style={{ textAlign: 'right' }}>
                                <Button htmlType="submit" loading={this.state.loading}>登入</Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default withRouterHistoryHook(LoginPage);